import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  tabs: {
    '.ant-tabs-nav': {
      width: 'fit-content'
    }
  }
}))
